// useMarket — small hook that reads the current URL and returns the active
// market config (from data/markets.js) or null when the URL is the global
// (non-localized) variant.
//
// Detects URLs of the form:
//   /us/cro                  → market=us
//   /uk/shopify-ecommerce    → market=uk
//   /cro                     → market=null   (global)
//
// Also returns: localizedHref(path) — generates a localized URL from a path,
// and otherMarkets — the list of OTHER market codes for hreflang generation.

import { useLocation } from "react-router-dom";
import { MARKETS_CONFIG, MARKET_CODES } from "../data/markets";

export function useMarket() {
  const { pathname } = useLocation();
  const segments = pathname.replace(/^\//, "").split("/");
  const first = (segments[0] || "").toLowerCase();
  const isMarket = MARKET_CODES.includes(first);

  const code = isMarket ? first : null;
  const market = code ? MARKETS_CONFIG[code] : null;
  const slug = isMarket ? segments[1] || "" : segments[0] || "";

  return {
    market,            // the full market config object, or null
    code,              // "us" | "uk" | ... | null
    slug,              // the page slug (e.g. "cro")
    isLocalised: !!market,

    // Build an href for the current page slug under a different market.
    localizedHref: (newCode) => {
      if (!newCode) return `/${slug}`;
      return `/${newCode}/${slug}`;
    },

    // Generate all market hrefs for the current slug — used for hreflang tags.
    hreflangs: () =>
      MARKET_CODES.map((c) => ({
        code: c,
        locale: MARKETS_CONFIG[c].locale.replace("_", "-"),
        href: `https://lumotis.com/${c}/${slug}`,
      })),
  };
}
